import { DEFAULT_AMOUNT_SAMPLE } from "@app/pages/samples/utils/constants";
import { getCommonDefaultValues } from "../../utils/getCommonDefaultValues";

export const getDefaultValuesTritioVapor = (defaultPreloadValues) => {
  const { currentPreparationIndex, currentCounting, currentCalculation } =
    defaultPreloadValues;

  const currentCountingIndex =
    currentPreparationIndex?.countings?.[currentCounting?.index as number];
  const currentCalculationIndex =
    currentCountingIndex?.calculations[currentCalculation?.index as number];

  const commonValues = getCommonDefaultValues(defaultPreloadValues);

  const volumeRegistriesData = currentPreparationIndex?.volumeRegistries || [];

  let rowsVolumeData = [
    {
      id: 1,
      volumen_agua_muestra_acumulada: "Volumen total aire por muestra (m³)",
      volumen_aire_muestreado_muestra: 0,
      total_aire_muestreado: 0,
    },
  ];

  let totalValueVolumeTritioAir = 0;

  if (volumeRegistriesData.length > 0) {
    const muestraFields = volumeRegistriesData.reduce((acc, registry) => {
      const index = parseInt(registry["position_volume_tritio_air"]) + 1;
      const valueVolume = parseFloat(registry["value_volume_tritio_air"]);

      acc[`muestra_${index}`] = registry["value_volume_tritio_air"] || 0;
      totalValueVolumeTritioAir += valueVolume;
      return acc;
    }, {} as Record<string, number>);

    rowsVolumeData = [
      {
        ...muestraFields,
        id: 1,
        volumen_agua_muestra_acumulada: "Volumen total aire por muestra (m³)",
        volumen_aire_muestreado_muestra: 0,
        total_aire_muestreado: totalValueVolumeTritioAir,
      },
    ];
  }

  const silicagelRegistriesInfoData =
    currentPreparationIndex?.silicagelRegistries || [];
  let totalValueBefore = 0;
  let totalValueAfter = 0;

  let rowsSilicaGelData = [
    {
      id: 1,
      description: "P. antes exp (g)",
      total_tramps: 0,
    },
    {
      id: 2,
      description: "P. después exp (g)",
      total_tramps: 0,
    },
  ];

  if (silicagelRegistriesInfoData.length > 0) {
    const trampaBeforeFields = silicagelRegistriesInfoData.reduce(
      (acc, registry) => {
        const index = parseInt(registry["position_silicagel_tritio_air"]) + 1;
        const valueBefore = parseFloat(
          registry["value_silicagel_before_tritio_air"]
        );

        acc[`trampa_${index}`] =
          registry["value_silicagel_before_tritio_air"] || 0;
        totalValueBefore += valueBefore;
        return acc;
      },
      {} as Record<string, number>
    );

    const trampaAfterFields = silicagelRegistriesInfoData.reduce(
      (acc, registry) => {
        const index = parseInt(registry["position_silicagel_tritio_air"]) + 1;
        const valueAfter = parseFloat(
          registry["value_silicagel_after_tritio_air"]
        );

        acc[`trampa_${index}`] =
          registry["value_silicagel_after_tritio_air"] || 0;
        totalValueAfter += valueAfter;
        return acc;
      },
      {} as Record<string, number>
    );

    rowsSilicaGelData = [
      {
        ...trampaBeforeFields,
        id: 1,
        description: "P. antes exp (g)",
        total_tramps: totalValueBefore,
      },
      {
        ...trampaAfterFields,
        id: 2,
        description: "P. después exp (g)",
        total_tramps: totalValueAfter,
      },
    ];
  }

  return {
    ...commonValues,

    //preparation
    analysis_amount_sample:
      currentPreparationIndex?.amount_sample || DEFAULT_AMOUNT_SAMPLE,
    scintillator_lot_number:
      currentPreparationIndex?.scintillator_lot_number || undefined,
    totalSampleWaterVolume:
      currentPreparationIndex?.total_sample_water_volume || 30, //TODO: implementar la precarga cuando este el backend
    sampleCountVapor: currentPreparationIndex?.sample_count_vapor || 0, //TODO: implementar la precarga cuando este el backend
    //sampledAirVolume: currentPreparationIndex?.sampled_air_volume || undefined, //TODO: implementar la precarga cuando este el backend
    numberOfTraps: currentPreparationIndex?.number_of_traps || undefined, //TODO: implementar la precarga cuando este el backend
    sampledAirVolumeSilicagel:
      currentPreparationIndex?.sampled_air_volume_silicagel || undefined,
    analyzedAirVolume:
      currentPreparationIndex?.analyzed_air_volume || undefined, //TODO: implementar la precarga cuando este el backend
    analyzedWaterVolume: currentPreparationIndex?.analyzed_water_volume || 10, //10, //TODO: implementar la precarga cuando este el backend
    rowsVolumeData:
      currentPreparationIndex?.sample_count_vapor > 0 ? rowsVolumeData : [], //TODO: implementar la precarga cuando este el backend
    rowsSilicaGelData: rowsSilicaGelData,
    //counting
    //calculation
    calculation_method: currentCalculationIndex?.calculation_method || "ISO",
  };
};
